import useProcessOverviewData from "./useProcessOverviewData";

const useSplitOverviewData = (overviewData , getTrend=true) => {
  const {
    managedDevice,
    totalUsers,
    notScannedCount,
    totalHardware,
    hardwareVendors,
    hardwareTypes,
    totalSoftware,
    commercialSoftware,
    nonCommercialSoftware,
    prohibitedSoftware,
    underLicensePercentage,
    overLicensePercentage,
    licenseInCompliancePercentage,
    licenseExpiredPercentage,
    underLicense,
    overLicense,
    licenseInCompliance,
    licenseExpired,
    osWindows,
    osMAC,
    osLinux,
    osIOS,
    osAndroid,
    deviceLaptop,
    deviceDesktop,
    deviceServer,
    deviceTablet,
    deviceOthers,
    // compliance data
    compliance,
    nonCompliance,
    inGracePeriod,
    notEvaluated,
  } = overviewData;

  const deviceOsSummaryData = {
    Windows: osWindows,
    MAC: osMAC,
    Linux: osLinux,
    iOS: osIOS,
    Android: osAndroid,
  };

  const deviceTypeSummaryData = {
    Desktop: deviceDesktop,
    Laptop: deviceLaptop,
    Tablet: deviceTablet,
    Server: deviceServer,
    Others: deviceOthers,
  };

  const softwareTypeSummaryData = {
    "Commercial SW": Math.ceil((commercialSoftware * 1000) / totalSoftware) / 10,
    "Non Commercial": Math.ceil((nonCommercialSoftware * 1000) / totalSoftware) / 10,
    "Prohibited SW": Math.ceil((prohibitedSoftware * 1000) / totalSoftware) / 10,
    counts: { Commercial: commercialSoftware, "Non Commercial": nonCommercialSoftware, Prohibited: prohibitedSoftware, Total: totalSoftware },
  };

  const softwareLicenseSummaryData = {
    "Under License": {
      percent: underLicensePercentage,
      value: underLicense,
    },
    "Over License": {
      percent: overLicensePercentage,
      value: overLicense,
    },
    "License In-Compliance": {
      percent: licenseInCompliancePercentage,
      value: licenseInCompliance,
    },
    "License Expired": {
      percent: licenseExpiredPercentage,
      value: licenseExpired,
    },
  };

  const deviceComplianceData = {
    Compliance: compliance,
    "Non Compliance": nonCompliance,
    "In Grace Period": inGracePeriod,
    "Not Evaluated": notEvaluated,
  };

  const { overviewCardsData, softwareTypeTrendData } = useProcessOverviewData(
    managedDevice,
    totalUsers,
    totalSoftware,
    prohibitedSoftware,
    nonCompliance,
    getTrend,

  );

  return {
    overviewCardsData,
    deviceOsSummaryData,
    deviceTypeSummaryData,
    softwareTypeSummaryData,
    softwareTypeTrendData,
    softwareLicenseSummaryData,
    deviceComplianceData,
  };
};

export default useSplitOverviewData;
